import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import {
  loadPersistedState,
  savePersistedState,
} from './signal-store-persist.util';

interface PreservationStoreState {
  diagnosticPath: string;
}

const STORAGE_KEY = 'vault_preservation_state';
const STORAGE_VERSION = 1;

const persistConfig = {
  key: STORAGE_KEY,
  version: STORAGE_VERSION,
  storage: 'session' as const,
};

const initialState: PreservationStoreState = {
  diagnosticPath: '',
};

function isPreservationPersistedState(
  value: unknown,
): value is PreservationStoreState {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  return typeof v['diagnosticPath'] === 'string';
}

const persistedInitialState: PreservationStoreState = {
  ...initialState,
  ...(loadPersistedState(
    persistConfig,
    isPreservationPersistedState,
  ) ?? {}),
};

export const preservationStore = signalStore(
  { providedIn: 'root' },
  withState(persistedInitialState),
  withMethods((store) => ({
    setDiagnosticPath(path: string): void {
      patchState(store, { diagnosticPath: path ?? '' });
      savePersistedState(persistConfig, { diagnosticPath: store.diagnosticPath() });
    },
  })),
);

export type PreservationStore = typeof preservationStore;
